var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pb-5"},[_c('h5',{staticClass:"pt-5 pb-4 fw-600"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"fs-6"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }